// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover .result{border:0;padding:5px;background:#fff;font-size:12px}.el-popover .string{color:green}.el-popover .number{color:#ff8c00}.el-popover .boolean{color:#00f}.el-popover .null{color:#f0f}.el-popover .key{color:red}", ""]);
// Exports
module.exports = exports;
